import { AuditStationPage } from '@app/modules/audit/modules/station-audit/components/AuditStationPage';
import { StationSchedulesListPage } from './StationSchedulesListPage';

/**
 * Wraps the schedules list page in the audit station layout for station-scoped audit routes.
 */
export function AuditSchedulesListPageAdapter() {
  return (
    <AuditStationPage>
      <StationSchedulesListPage />
    </AuditStationPage>
  );
}
